import {Pressable, StyleSheet} from "react-native";
import React from "react";
import {useNavigation, useTheme} from "@react-navigation/native";
import {useSelector} from "react-redux";
import {FontAwesome} from "@expo/vector-icons";

export default function MatrixTaskButton(props) {
    const {  title = 'Matrix', id, matrix } = props;
    const navigation = useNavigation();
    const currentTheme = useSelector(state => state.theme);
    const theme = useTheme();
    const buttonColor = [currentTheme === 'contrast-light' ? theme.colors.scheme[5] : theme.colors.scheme[3], '#c02121', '#cc6e21', '#cbc11d', '#40c056'];
    const styles = StyleSheet.create({
        square: {
            fontSize:8,
            position:'absolute',
            color: theme.colors.scheme[4]
        },
        button: {
            position:'relative',
            display: 'flex',
            width: 32,
            height:32,
            //backgroundColor: colorSchemes[activeScheme][3],
            backgroundColor: buttonColor[matrix],
            fontFamily: 'Roboto-Regular',
            fontSize:16,
            marginHorizontal:2,
            borderWidth: 0,
            borderRadius: 100,
            justifyContent:'center',
            alignItems:'center'
        }
    });
    return (
        <Pressable style={(({ pressed }) => [
            { opacity: pressed ? 0.5 : 1.0 }, styles.button
        ])} onPress={() => {
            navigation.navigate('Matrix', {task: {id: id, matrix:matrix}})
        }}>
            <FontAwesome style={[styles.square, (matrix === 1 ? {opacity:1} : {opacity: 0.25}), {top:8, left:8}]} name={'square'} />
            <FontAwesome style={[styles.square, (matrix === 2 ? {opacity:1} : {opacity: 0.25}), {top:8, right:8}]} name={'square'} />
            <FontAwesome style={[styles.square, (matrix === 3 ? {opacity:1} : {opacity: 0.25}), {bottom:8, left:8}]} name={'square'} />
            <FontAwesome style={[styles.square, (matrix === 4 ? {opacity:1} : {opacity: 0.25}), {bottom:8, right:8}]} name={'square'} />
        </Pressable>
    );
}